import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=aa7dc056&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=aa7dc056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7dc056",
  null
  
)

export default component.exports